import { useLazyQuery, useQuery } from "@apollo/client";
import { TASKS } from "../task.queries";
import { TasksQuery, TasksQueryVariables } from "../../../__generated__/TasksQuery";

export const useTasks = (variables: TasksQueryVariables) => {
  return useQuery<TasksQuery, TasksQueryVariables>(TASKS, { variables });
};

export const useLazyTasks = () => {
  return useLazyQuery<TasksQuery, TasksQueryVariables>(TASKS);
};
